import { LoginUserAdapter } from "./adapter/login-user";
import { MFAAdapter } from "./adapter/mfa";

import { LoginUser } from "./type/login-user";
import { IAuthRepo } from "./irepo";

import { TError } from "../../types/error";

export class AuthUsecase {
  private repo: IAuthRepo;
  private error: (error: TError) => void;

  constructor(repo: IAuthRepo, error: (error: TError) => void) {
    this.repo = repo;
    this.error = error;
  }

  async loginAccount(req: any): Promise<any> {
    try {
      return await this.repo.loginAccount(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async setupAccount(req: any): Promise<any> {
    try {
      return await this.repo.setupAccount(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async setupVerify(req: any): Promise<any> {
    try {
      return await this.repo.setupVerify(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async setupMFA(req: any): Promise<any> {
    try {
      const data = await this.repo.setupMFA(req);
      return MFAAdapter.toSetupMFAOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async verifyMFA(req: any): Promise<any> {
    try {
      const data = await this.repo.verifyMFA(req);
      return MFAAdapter.toVerifyMFAOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async resetPassword(req: any): Promise<any> {
    try {
      return await this.repo.resetPassword(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async verifyPassword(req: any): Promise<any> {
    try {
      return await this.repo.verifyPassword(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async checkTerms(req: any): Promise<any> {
    try {
      return await this.repo.checkTerms(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async verifyTerms(req: any): Promise<any> {
    try {
      return await this.repo.verifyTerms(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchLoginUser(req: any): Promise<any> {
    try {
      const [clientData, userData, verData] = await Promise.all([
        this.repo.fetchClient(req),
        this.repo.fetchUser(req),
        this.repo.fetchVersion(req),
      ]);
      return { user: LoginUserAdapter.toOutputDTO({ clientData, userData }), is_reload: verData.is_reload }
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async keepTrial(): Promise<any> {
    try {
      return await this.repo.keepTrial();
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async skipTrial(): Promise<any> {
    try {
      return await this.repo.skipTrial();
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }
}
